import { Typography } from './Typography';

import type { TypographyProps } from './Typography';
import type { FC } from 'react';
import type { Modify } from '@toolbox/utils';

type CaptionTypography = 'c1' | 'c2';
export type CaptionProps = Modify<TypographyProps, { variant?: CaptionTypography }>;

export const Caption: FC<CaptionProps> = (props) => {
  return <Typography {...props} />;
};

Caption.defaultProps = {
  variant: 'c1',
};
